export const state = () => ({
  registerType: null,
  modalRegister: false,
  tab: 'account',
  data: '',
  token: '',
  login: null,
  doctorData: null,
  finalUrlRegisterDoctor: null
})

export const mutations = {
  SET_REGISTER_TYPE: (state, data) => {
    state.registerType = data
  },
  SET_MODAL_REGISTER: (state, data) => {
    state.modalRegister = data
  },
  SET_TAB: (state, data) => {
    state.tab = data
  },
  SET_TOKEN: (state, data) => {
    state.token = data
  },
  SET_DOCTOR_LOGIN: (state, data) => {
    state.login = data
  },
  SET_DOCTOR_DATA: (state, data) => {
    state.doctorData = data
  },
  SET_FINAL_URL_REGISTER_DOCTOR: (state, data) => {
    state.finalUrlRegisterDoctor = data
  }
}

export const actions = {
  submitContact ({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('FullName', payload.name)
      formData.append('Email', payload.email)
      formData.append('Message', payload.message)

      this.$axios.post('/network/contact', formData, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        resolve(response)
      }).catch(function (error) {
        reject(error)
      })
    })
  },
  getDataMe ({ rootState, commit, dispatch, $axios }, payload) {
    return new Promise((resolve, reject) => {
      this.$axios.get('/clinic/verification/check' + `${payload.token ? `?token=${payload.token}` : ''}`, {
        headers: {
          DeviceType: 'web'
        }
      }).then(function (responseInfo) {
        const dataInfo = responseInfo.data
        resolve(dataInfo)
      }).catch(function (error) {
        reject(error)
      })
    })
  },
  loginAsDoc ({ rootState, commit, dispatch, $axios }, payload) {
    const { Email, Password } = payload
    return new Promise((resolve, reject) => {
      const formData = {
        Email
      }

      if (typeof Password !== 'undefined' && Password) {
        Object.assign(formData, {
          Password
        })
      }

      const self = this

      this.$axios.post('/doctoradmin/login', formData, {
        headers: {
          DeviceType: 'web'
        }
      })
        .then(function (response) {
          const res = response.data
          const data = res.Data
          if (data) {
            if (data.Token && data.Role === 'DOCTOR') {
              commit('SET_DOCTOR_LOGIN', response)
              commit('SET_TOKEN', data.Token)

              localStorage.setItem('doctor-token', JSON.stringify(data.Token))

              self.$axios.get('/doctor/me', {
                headers: {
                  DeviceType: 'web'
                }
              }).then(function (responseInfo) {
                const dataInfo = responseInfo.data.Data
                localStorage.setItem('doctor-data', JSON.stringify(dataInfo))
                commit('SET_DOCTOR_DATA', dataInfo)
              }).catch(function (error) {
                reject(error)
              })
              resolve(response)
            }
          } else {
            resolve(response)
          }
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  async getProfileDoctor () {
    return await this.$axios.get('/doctor/me')
  }
}
